/* eslint-disable react/prop-types */
import React, {
  useState,
  useRef,
  useEffect
} from 'react';
import { Tooltip } from 'reactstrap';

function EllipsisText(props) {
  const {
    onClick,
    isMultiLine = false,
    id,
    className,
    modifiers,
    placement,
    children
  } = props;

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const isMounted = useRef(false);
  const elId = `tt-${id}`;

  useEffect(() => {
    isMounted.current = true;
    return () => { isMounted.current = false; };
  }, []);

  const hideTooltip = () => {
    if (isMounted.current) {
      setTooltipOpen(false);
    }
    return true;
  };

  const toggle = ({ target }) => {
    const {
      scrollWidth, clientWidth, scrollHeight, clientHeight
    } = target;
    if ((scrollWidth > clientWidth) || (isMultiLine && (scrollHeight > clientHeight))) {
      setTooltipOpen(!tooltipOpen);
    }

    const scrollBarContainer = document.querySelector('#scrollBarContainer');
    if (scrollBarContainer) {
      scrollBarContainer.addEventListener('ps-scroll-y', hideTooltip);
    }
  };

  return (
    <>
      <div className={`${className} ${isMultiLine ? 'text-ellipsis-multiline' : 'text-ellipsis'}`} id={elId} onClick={onClick || null} aria-hidden="true">{children}</div>
      <Tooltip className="ca-tooltip" modifiers={modifiers || null} fade={false} placement={placement || 'auto'} isOpen={tooltipOpen} target={elId} toggle={toggle}>
        {children}
      </Tooltip>
    </>
  );
}

export default EllipsisText;
